// Counts, grouped the English way whatever the viewer's language or region
// (FR-HIST-05): the words around them are English, and English as some
// regions write it groups "2.000" or "2 000", which an English reader takes
// for two. The server writes each count as
// <data class="count" value="12034">12,034</data> (src/ui/chat.rs); this
// writes the text with a fixed US formatter, as the seed's count of its
// design notes is (seed.ts), on load and whenever a swap or a streamed
// update adds one. Without JavaScript the server's commas stay.

const FORMAT = new Intl.NumberFormat("en-US");

const SELECTOR = "data.count[value]";

function localise(el: HTMLDataElement): void {
  const n = Number(el.value);
  if (!Number.isSafeInteger(n)) return;
  const text = FORMAT.format(n);
  if (el.textContent !== text) el.textContent = text;
}

function localiseWithin(root: ParentNode | Element): void {
  if (root instanceof HTMLDataElement && root.matches(SELECTOR)) {
    localise(root);
  }
  for (const el of root.querySelectorAll<HTMLDataElement>(SELECTOR)) {
    localise(el);
  }
}

export function installLocalCounts(): void {
  localiseWithin(document);
  // As for times (time.ts): every way new HTML arrives ends as a DOM
  // insertion, so one observer covers them all.
  new MutationObserver((records) => {
    for (const r of records) {
      for (const node of r.addedNodes) {
        if (node instanceof Element) localiseWithin(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  // As for times: a morph writes a count back without adding it.
  document.addEventListener("htmx:after:settle", (event) => {
    const added: unknown = (event as CustomEvent).detail?.newContent;
    if (!Array.isArray(added)) return;
    for (const node of added) {
      if (node instanceof Element) localiseWithin(node);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", installLocalCounts);
} else {
  installLocalCounts();
}
